import axios from "axios";
const BASE = process.env.REACT_APP_API_URL
const url = BASE;

export const handleContactUs = (data) => {
  let response = axios.post(`${url}contact-us`, data);
  return response;
};